// extracted by mini-css-extract-plugin
export default {"collapseContainer":"AudioPreviewCollapseSection_collapseContainer__V-otW"};